import { useMediaQuery } from '@react-hook/media-query';

import { theme } from '@/styles';

export const useIsMobile = (): boolean =>
  useMediaQuery(`(max-width: ${theme.breakpoints.siteBreakpoint - 1}px)`);

export default useIsMobile;
